import React from 'react';

const TextQRForm = ({ qrText, onTextChange }) => {
  return (
    <div className="form-group">
      <label htmlFor="qrText">Texto</label>
      <textarea
        id="qrText"
        value={qrText}
        onChange={(e) => onTextChange(e.target.value)}
        placeholder="Digite qualquer texto aqui..."
        className="text-area"
        rows="4"
      />
      <small>Qualquer texto simples (máximo 2953 caracteres)</small>
    </div>
  );
};

export default TextQRForm;
